import * as yup from "yup";

export const callsFormSchema = yup.object().shape({
  type: yup.string(),
  feedback: yup.string().required("É necessário escrever uma justificativa."),
  grade: yup.string().typeError("É necessário uma nova nota"),
});
